import React, { useState, useEffect } from "react";
import {
  Layout,
  Breadcrumb,
  Button,
  Table,
  Row,
  Spin,
  Card,
  Col,
  message,
} from "antd";
import axios from "axios";
import { APPBACKGROUND_COLOR, MAINAPIURL } from "../appsettings";
import { AlertError, AlertSuccess } from "../usableclasses";
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
const { Content } = Layout;

const columns = [
  { title: "Year", dataIndex: "sysYear", key: "sysYear", align: "left" },
  { title: "Month", dataIndex: "sysMonth", key: "sysMonth", align: "left" },
  { title: "Seq.Order", dataIndex: "processOrder", key: "processOrder", align: "left" },
  { title: "Code", dataIndex: "processCode", key: "processCode", align: "left" },
  { title: "Name", dataIndex: "processName", key: "processName", align: "left" },
  { title: "Status", dataIndex: "processStatus", key: "processStatus", align: "left" },
  { title: "Start DT", dataIndex: "processStart", key: "processStart", align: "left" },
  { title: "Done DT", dataIndex: "processEnd", key: "processEnd", align: "left" }
];

const MonthendProcess = () => {
  const ApiURL = MAINAPIURL;
  const TOKEN = localStorage.getItem("AUTHCODE");
  const [isLoading, setIsLoading] = useState(false);
    const [processList, setProcessList] = useState([]);

  useEffect(() => {
    
    fetchAllProcess();

  }, []);

  const fetchAllProcess = async () => {
    
    try {
      setIsLoading(true);
      const headers = { SystemAccessToken: TOKEN };
    
      const response = await axios.get(
        `${ApiURL}/settings/monthend/getcurrentmonthprocesslist`,
        { headers }
      );

      setProcessList(response.data);

    } catch (error) {
      AlertError("Failed to Load Process List");
    } finally {
      setIsLoading(false);
    }

  };

  const fetchCreateProcess = async () => {
    
      try {
        setIsLoading(true);
        const headers = { SystemAccessToken: TOKEN };
      
        const response = await axios.get(
          `${ApiURL}/settings/monthend/createallprocess`,
          { headers } );

          if(response.status == "200")
          {
            AlertSuccess("Process Created.");
          }
          else
          {
            AlertError("We found some error.");
          }

          const response_get = await axios.get(`${ApiURL}/settings/monthend/getcurrentmonthprocesslist`,
            { headers }
          );

          setProcessList(response_get.data);

      } catch (error) {
        AlertError("Failed to Create List");
      } finally {
        setIsLoading(false);
      }

    };

    const fetchNextProcess = async () => {
    
      try {
        setIsLoading(true);
        const headers = { SystemAccessToken: TOKEN };
      
        const response = await axios.get(
          `${ApiURL}/settings/monthend/executenextprocess`,
          { headers } );

          if(response.status == "200")
          {
            AlertSuccess("Successfully Run.");
          }
          else
          {
            AlertError("We found some error.");
          }

          const response_get = await axios.get(`${ApiURL}/settings/monthend/getcurrentmonthprocesslist`,
            { headers }
          );

          setProcessList(response_get.data);

      } catch (error) {
        AlertError("Failed to Load Process List");
      } finally {
        setIsLoading(false);
      }

    };

  return (
    <Spin spinning={isLoading} tip="Processing...">
      <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
        <Headerdiv />
        <Content style={{ padding: "10px" }}>
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
            <Breadcrumb.Item>Monthend Process</Breadcrumb.Item>
          </Breadcrumb>

          <Card title="Month-End Process List" style={{ marginBottom: 20 }}>
            <Row gutter={16} justify="flex-start" align="middle" style={{ marginBottom: 16 }}>
              <Col>
                <Button type="primary" onClick={fetchCreateProcess} loading={isLoading}>
                  Create Month End Processes
                </Button>
              </Col>
              <Col>
                <Button type="primary" onClick={fetchAllProcess} loading={isLoading}>
                  Refresh Process List
                </Button>
              </Col>
              <Col>
                <Button type="primary" onClick={fetchNextProcess} loading={isLoading}>
                  Execute Next Process
                </Button>
              </Col>
            </Row>

            <Table
              columns={columns}
              dataSource={processList}
              pagination={false}
              bordered
              scroll={{ x: "max-content" }}
              rowKey="processId"
            />

          </Card>

        </Content>
        <Footerdiv />
      </Layout>
    </Spin>
  );
};

export default MonthendProcess;
